import { render, staticRenderFns } from "./Update-Password.vue?vue&type=template&id=07c5408d&scoped=true&"
import script from "./Update-Password.vue?vue&type=script&lang=js&"
export * from "./Update-Password.vue?vue&type=script&lang=js&"
import style0 from "./Update-Password.vue?vue&type=style&index=0&id=07c5408d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c5408d",
  null
  
)

export default component.exports